import ButtonBody from './ButtonBody';

const View = (props) => <ButtonBody {...props} />;

export default View;
